
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","x1":"7.74","y1":"-971.13","x2":"16.09","y2":"-988.42","gradientTransform":"matrix(1 0 0 -1 0 -968)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#909090"}}),_c('stop',{attrs:{"offset":".37","stop-color":"#414141"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#212121"}})]),_c('path',{staticStyle:{"fill":"none","stroke":"none"},attrs:{"d":"M0 0h24v24H0z"}}),_c('circle',{attrs:{"cx":"12.03","cy":"12","r":"10"}}),_c('path',{staticStyle:{"fill":"url(#a)"},attrs:{"d":"M12 7.18A4.82 4.82 0 007.2 12 4.82 4.82 0 0012 7.18zM16.85 12V7.43a.25.25 0 00-.25-.25h-2.09a.26.26 0 00-.26.25v.3A4.74 4.74 0 0012 7.18 4.82 4.82 0 0016.85 12zM7.2 12a4.82 4.82 0 004.8 4.82A4.82 4.82 0 007.2 12zM12 2a10 10 0 000 20 10.16 10.16 0 002.33-.27.27.27 0 00.19-.32l-.54-2a.26.26 0 00-.3-.18 7.34 7.34 0 01-1.68.19 7.41 7.41 0 115.4-2.34.36.36 0 01-.24.1.36.36 0 01-.35-.36V12A4.82 4.82 0 0012 16.82a4.74 4.74 0 002.22-.55v.51a2.94 2.94 0 005 2.15l.05-.06A10 10 0 0012 2z"}}),_c('path',{staticStyle:{"fill":"#e4c96a"},attrs:{"d":"M6.2 9.4h1.32l1.12 3.21a1.84 1.84 0 01.12.45 2.12 2.12 0 01.12-.45L10 9.4h1.33l-1.85 5.21H8.06zM11.88 9.4h1.24v5.21h-1.24zM14.29 9.4H16a1.82 1.82 0 110 3.6h-.49v1.57h-1.22zM16 11.87a.59.59 0 00.59-.66.62.62 0 00-.59-.67h-.49v1.33z"}})])
          )
        }
      }
    